import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import Axios from "axios";
export var uploadImageFile = function(imageFile) {
    var formData = new FormData();
    formData.append("file", imageFile);
    return uploadImage(formData);
};
var uploadImage = function(formData, onUploadProgress) {
    var releaseVersion = getGlobalProperty("releaseVersion", "");
    return Axios.post("/api/image/upload", formData, {
        headers: {
            "content-type": "multipart/form-data",
            "X-IF-CLIENT-RELEASE": releaseVersion
        },
        withCredentials: true,
        onUploadProgress: onUploadProgress
    }).then(function(res) {
        return res.data;
    });
};
